import {
  ENewbuildingBrokerCallbackWidgetActionTypes,
  TNewbuildingBrokerCallbackWidgetActions,
} from 'shared/actions/newbuildingBrokerCallbackWidget';
import { IAppState } from 'shared/common/state';

export function newbuildingBrokerCallbackWidgetReducer(
  state: IAppState,
  action: TNewbuildingBrokerCallbackWidgetActions,
): IAppState {
  switch (action.type) {
    case ENewbuildingBrokerCallbackWidgetActionTypes.OpenWidget:
      return {
        ...state,
        newbuildingBrokerCallbackWidget: {
          ...state.newbuildingBrokerCallbackWidget,
          openingTrigger: true,
          offerInfo: action.payload,
        },
      };
    case ENewbuildingBrokerCallbackWidgetActionTypes.ResetOpeningTrigger:
      return {
        ...state,
        newbuildingBrokerCallbackWidget: {
          ...state.newbuildingBrokerCallbackWidget,
          openingTrigger: false,
          offerInfo: null,
        },
      };
    default:
      return state;
  }
}
